import { ListTile, SmartListView } from '@/components';
import { UserProfile, Username } from '@/features/users';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import './Mentionuser.scss';

const MentionUser = ({ participants = [], onUserSelect, selectedIndex }) => {
   const smartListRef = useRef(null);

   useEffect(() => {
      if (smartListRef.current && selectedIndex >= 0) {
         smartListRef.current.scrollToIndex({ index: selectedIndex, animated: false, block: 1 });
      }
   }, [selectedIndex]);

   if (!participants || participants.length === 0) return null;

   const renderItem = ({ item, index }) => {
      const isSelected = index === selectedIndex;
      return (
         <ListTile
            key={item.userId}
            className={`mention-user-item ${isSelected ? 'selected' : ''}`}
            onClick={() => onUserSelect(item.userProfile?.name || item.userProfile?.nickName || item.userId)}
            avatar={<UserProfile userId={item.userId} className="chat-avatar chat-avatar-fallback ct-flexCenter" />}
            title={<Username userId={item.userId} />}
         />
      );
   };

   return (
      <div className="mention-user-list ct-flex ct-fcol">
         <SmartListView
            id="mention-user-list-view"
            ref={smartListRef}
            data={participants}
            renderItem={renderItem}
            keyExtractor={item => item.userId}
            itemHeight={52}
            overscan={5}
            enableVirtualization={participants.length > 10}
         />
      </div>
   );
};

MentionUser.propTypes = {
   participants: PropTypes.arrayOf(
      PropTypes.shape({
         userId: PropTypes.string.isRequired,
         userProfile: PropTypes.shape({
            name: PropTypes.string,
            nickName: PropTypes.string,
         }),
      }),
   ),
   onUserSelect: PropTypes.func.isRequired,
   selectedIndex: PropTypes.number,
};

export default MentionUser;
